/**
 * The UrlHelper bundles useful static functions for url and uri handling
 */
export default abstract class UrlHelper {
	/**
	 * Returns the currently set search parameter from the window location as {@link URLSearchParams}.
	 */
	public static getSearchParams(): URLSearchParams {
		return new URLSearchParams(window.location.search);
	}

	/**
	 * Returns a specific search parameter from the current window location with the given key.
	 */
	public static getSearchParam(key: string): string | null {
		return UrlHelper.getSearchParams().get(key);
	}

	/**
	 * Checks if the given string is a valid url path
	 */
	public static isUrlPath(value: string): boolean {
		let regexp: RegExp = /^([a-zA-Z0-9/])+$/;
		return regexp.test(value);
	}
}